import React from 'react';
import ReactDOM from 'react-dom';
import App from './containers/App';

// 启动React应用
ReactDOM.render(<App />, document.getElementById('app'));
